



















import { mdiCloseCircle, mdiCheckboxMarkedCircle } from '@mdi/js';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { StatementsModule } from '@/store/modules/statements';
// eslint-disable-next-line no-unused-vars
import { IStatementShortInfo } from '@/utils/types';
import Filters from '@/components/elements/statement/Filters.vue';
import StatementsList from '@/components/elements/statement/StatementsList.vue';

@Component({
  components: { Filters, StatementsList },
  data() {
    return {
      mdiCloseCircle,
      mdiCheckboxMarkedCircle,
    };
  },
})
export default class StatementsTable extends Vue {
  @Prop(Number) limit?: number;
  @Prop(Boolean) paginationShow?: boolean;
  @Prop({ type: String, default: 'Нет данных' }) notDataText?: string;
  @Prop({ type: Boolean, default: false }) filters?: string;

  private dataTable: IStatementShortInfo[] = [];
  loading: boolean = false;
  private allCount: number | null = null;
  private currentPage: number = 1;
  private pageSize: number = 15;

  async mounted() {
    const payload = {
      extId: '',
      statementType: '',
      createDate: '',
      status: [],
    };

    if (this.$route.name === 'Statements') {
      const filterLS = await StatementsModule.getFilterLocalStorage();
      payload.extId = filterLS && filterLS.extId ? filterLS.extId : '';
      payload.statementType =
        filterLS && filterLS.statementType ? filterLS.statementType : '';
      payload.createDate =
        filterLS && filterLS.createDate ? filterLS.createDate : '';
      payload.status =
        filterLS && filterLS.status ? [...filterLS.status] : ([] as any);
    }

    StatementsModule.changePageSize(this.pageSize);
    StatementsModule.changePageNumber(this.currentPage - 1);
    await StatementsModule.filter({ ...payload });
    await this.getData();
  }

  async getData() {
    this.loading = true;
    if (this.limit) {
      await StatementsModule.changePageSize(this.limit);
    }
    await StatementsModule.loadAllUserStatements();
    this.allCount = StatementsModule.totalCount;
    this.dataTable = StatementsModule.list;
    this.loading = false;
  }

  async onChangePage(val: number) {
    this.currentPage = val;
    await StatementsModule.changePageNumber(val - 1);
    await this.getData();
  }

  async onChangeLimit(val: number) {
    this.loading = true;
    this.currentPage = 1;
    this.pageSize = val;
    await StatementsModule.changePageNumber(0);
    await StatementsModule.changePageSize(val);
    await StatementsModule.loadAllUserStatements();
    this.dataTable = StatementsModule.list;
    this.allCount = StatementsModule.totalCount;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  async onChangeFilter() {
    this.loading = true;
    this.currentPage = 1;
    await StatementsModule.changePageNumber(0);
    await StatementsModule.loadAllUserStatements();
    this.dataTable = StatementsModule.list;
    this.allCount = StatementsModule.totalCount;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  go(id: string) {
    this.$router.push({ name: 'StatementDetail', params: { id: id } });
  }
}
